<template>
  <div class="layout-header" :class="`layout-header_en`">
    <div class="layout-nav-header">
      <div class="layout-nav-header-main">
        <div class="layout-nav-header-left">
          <layout-logo></layout-logo>
        </div>
        <div class="layout-nav-header-menu">
          <LayoutMenu
            :menus="headerMenuConfig"
            mode="horizontal"
          ></LayoutMenu>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import {mapActions, mapState} from 'vuex';
  import {headerMenuConfig} from '@/menuConfig';
  import imgGd from '@/assets/images/logo.png';
  import LayoutLogo from '../../components/LayoutLogo';
  import LayoutMenu from '@/components/LayoutMenu';

  export default {
    name: 'NavBar',
    components: {
      LayoutLogo,
      LayoutMenu,
    },
    data() {
      return {
        headerMenuConfig,
        imgGd,
        pdfDoc: null, // pdfjs 生成的对象
        pageNum: 1, //
        pageRendering: false,
        pageNumPending: null,
        scale: 1.2, // 放大倍数
        page_num: 0, // 当前页数
        page_count: 0, // 总页数
        maxscale: 2, // 最大放大倍数
        minscale: 0.8, // 最小放大倍数
        canvasData: [],
        pdfjsView: false,
        pdfurl: null,
        loading: false,
        remainDay: 0,
        name: ''
      };
    },
    methods: {
      ...mapActions('account', [
        'logout'
      ]),
      handleSelect(index, indexPath) {
        this.$router.push(index);
      },
    },
    computed: {
      ...mapState('user', ['info']),
      // triggerClass() {
      //     return this.isCollapse ? 'el-icon-s-unfold' : 'el-icon-s-fold'
      // }
    }
  };
</script>

<style lang="less">
  .layout-header {
    padding: 0;
    height: 130px;
    widows: 100;
    z-index: 2;
    background: white;

    .el-submenu__title {
      padding: 0 10px;
    }

    &_en {
      .el-submenu__title {
        padding: 0 4px;
      }
    }
  }

  .layout-nav-header-left {
    padding: 0 10px 0 0;
  }

  .layout-nav-header {
    position: relative;
    display: flex;
    justify-content: space-between;
    width: 100%;
    height: 130px;
    //box-shadow: 0 1px 4px rgba(0, 21, 41, 0.08);
    transition: background 0.3s, width 0.2s;
  }

  .layout-nav-header-main {
    display: flex;
    flex: 1;
  }

  .layout-nav-header-menu {
    margin: auto;
    display: flex;
    flex: 1;

    .el-menu.el-menu--horizontal {
      border-bottom: none;
    }
  }

  .layout-nav-header-global {
    height: 50px;
    margin-left: 40px;
    float: right;
    overflow: hidden;
    color: hsla(0, 0%, 100%, 0.85);

    .user-profile-container {
      cursor: pointer;

      .user-profile-content {
        display: flex;
        padding: 10px 0;
      }

      .menu-icons {
        display: flex;
        align-items: center;

        .menu-icon {
          padding: 0 5px;

          .icon {
            display: inline-block;
            font-size: 18px;
            text-align: center;
          }
        }
      }

      .user-profile-body {
        position: relative;
        display: flex;
        flex-direction: row;
        align-items: center;
        justify-content: center;
        text-align: center;
        padding-right: 14px;
      }

      .user-avatar {
        width: 24px;
        height: 24px;
        margin: 0 8px 0 12px;
        border-radius: 4px;
      }

      .user-name {
        color: hsla(0, 100%, 1%, 0.85);
      }

      .user-department {
        font-size: 12px;
        color: rgba(102, 102, 102, 0.65);
      }

      .el-icon-caret-bottom {
        position: absolute;
        right: 0;
        top: 13px;
        font-size: 12px;
      }
    }

    .language {
      color: hsla(0, 0%, 100%, 0.85);
      line-height: 24px;
    }
  }

  .prompt-icon {
    width: 25px;
  }

  .cpdf {
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    z-index: 99999;
    display: flex;
    justify-content: center;
    align-items: center;

    .center {
      text-align: center;
      height: 100%;
      overflow: auto;
      padding-top: 20px;

      .contor {
        margin-bottom: 10px;
      }
    }

    .page-foot {
      position: fixed;
      left: 0px;
      bottom: 0px;
      width: 100%;
      height: 56px;
      line-height: 56px;
      background-color: #fff;
      text-align: center;
      z-index: 10;

      .foot-button {
        display: inline-block;
        height: 56px;
        position: relative;
        top: -22px;
        left: 20px;
      }
    }
  }
</style>




// WEBPACK FOOTER //
// src/layouts/HeaderLayout/components/NavBar.vue